// firstDateService.js
import apiClient from '../../../../services/apiClient';
import { getRequestsList } from '../../../statistic_public/actions';

export const firstDateService = {
  /**
   * Отримати список заявок за номером свідоцтва про народження
   * @param {string} birthCertificate
   */
  async getApplicationsByBirthCertificate(birthCertificate) {
    const result = await getRequestsList({
      search: birthCertificate,
      pageSize: 100,
      fieldsCons: {
        id: '_id',
        date: 'createdAt',
        childName: 'child.firstName',
        childLastName: 'child.lastName',
        childBirthDate: 'child.birthDate',
        number: 'registrationNumber',
        birthCertificate: 'child.birthCertificate.number',
        email: 'responsiblePerson.contacts.email',
        firstDate: 'firstDate',
      },
    });

    return result;
  },

  /**
   * Оновити дату першої реєстрації для заявки
   * @param {string} requestId
   * @param {string} firstDate  — ISO date string (YYYY-MM-DD)
   */
  async updateFirstDate(requestId, firstDate) {
    return apiClient.post('requests/first_date', {
      requestId,
      firstDate,
    });
  },
};